// ACTA_THEME_COLORS_V49
// Palette fonctionnelle commune aux statuts, graphiques et cartes.
// Les valeurs visuelles restent pilotées par les variables CSS du thème.

export const THEME_COLORS = Object.freeze({
  primary: "var(--do-accent)",
  primaryStrong: "var(--do-accent-strong)",
  success: "var(--do-success)",
  warning: "var(--do-warning)",
  danger: "var(--do-danger)",
  neutral: "var(--do-neutral)",
  violet: "var(--do-data-violet)",
  sky: "var(--do-data-sky)",
  teal: "var(--do-data-teal)",
  orange: "var(--do-data-orange)",
});

export const PIPELINE_COLORS = Object.freeze({
  lead: THEME_COLORS.primary,
  opportunity: THEME_COLORS.violet,
  proposal: THEME_COLORS.warning,
  won: THEME_COLORS.success,
  lost: THEME_COLORS.danger,
});

export const GMAO_STATUS_COLORS = Object.freeze({
  operational: THEME_COLORS.success,
  attention_required: THEME_COLORS.warning,
  broken_down: THEME_COLORS.danger,
  neutral: THEME_COLORS.neutral,
});
